<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card
      v-if="billing"
      flat
      class="rounded-card">
      <v-card-title>
        請求管理詳細
      </v-card-title>
      <v-card-subtitle>
        {{ billing.billing_name }}
      </v-card-subtitle>
      <!-- 検索項目 -->
      <v-row>
        <v-col>
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header class="panel-header-color panel-selectable">
                <strong>
                  <v-icon class="panel-header-color">
                    mdi-magnify
                  </v-icon>
                  &nbsp;条件を指定して検索
                </strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-select
                          v-model="searchForms.sortType1"
                          :items="sortMembers"
                          background-color="white"
                          dense
                          hide-details="auto"
                          label="並び替え1"
                          outlined
                          persistent-placeholder
                          rounded
                          clearable
                          style="font-size: 80%"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          v-model="searchForms.sortType2"
                          :items="sortMembers"
                          background-color="white"
                          dense
                          hide-details="auto"
                          label="並び替え2"
                          outlined
                          persistent-placeholder
                          rounded
                          clearable
                          style="font-size: 80%"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          v-model="searchForms.sortType3"
                          :items="sortMembers"
                          background-color="white"
                          dense
                          hide-details="auto"
                          label="並び替え3"
                          outlined
                          persistent-placeholder
                          rounded
                          clearable
                          style="font-size: 80%"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          v-model="searchForms.sortType4"
                          :items="sortMembers"
                          background-color="white"
                          dense
                          hide-details="auto"
                          label="並び替え4"
                          outlined
                          persistent-placeholder
                          rounded
                          clearable
                          style="font-size: 80%"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          v-model="searchForms.sortType5"
                          :items="sortMembers"
                          background-color="white"
                          dense
                          hide-details="auto"
                          label="並び替え5"
                          outlined
                          persistent-placeholder
                          rounded
                          clearable
                          style="font-size: 80%"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="searchButtonClickEvent"
                    >
                      <v-icon>
                        mdi-magnify
                      </v-icon>
                      &nbsp;検索
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <!-- /検索項目 -->
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              小計金額（税抜）
            </div>
            <h4 class="text-right">
              {{ parseFloat(billing.subtotal_amount) | comma_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              消費税金額
            </div>
            <h4 class="text-right">
              {{ parseFloat(billing.tax_amount) | comma_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              非課税対象
            </div>
            <h4 class="text-right">
              {{ parseFloat(billing.tax_exempt_amount) | comma_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              合計金額
            </div>
            <h4 class="text-right">
              {{ parseFloat(billing.total_amount) | comma_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="billing.deal_details"
          dense
          hide-default-footer
          disable-sort
          :items-per-page="-1"
        >
          <template v-slot:[`item.trading_date`]="{item}">
            <div>
              {{ item.trading_date | date_format }}
            </div>
            <div>
              {{ item.sales_date | date_format }}
            </div>
          </template>
          <template v-slot:[`item.emission`]="{item}">
            <div :title="item.emission.name">
              <small>{{ item.emission.name | truncate(15) }}</small>
            </div>
            <div :title="item.emission.location_name">
              <small>{{ item.emission.location_name || '-' | truncate(15)  }}</small>
            </div>
          </template>

          <template v-slot:[`item.quantity`]="{ item }">
            {{ parseFloat(item.quantity) | comma_format }}
          </template>
          <template v-slot:[`item.unit_price`]="{ item }">
            {{ parseFloat(item.unit_price) | comma_format }}
          </template>
          <template v-slot:[`item.detailed_amount`]="{ item }">
            {{ parseFloat(item.detailed_amount) | comma_format }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="backButtonClickEvent"
        >
          戻る
        </v-btn>
      </v-card-actions>

      <!-- ページャ -->
      <v-row
        v-if="hasResult"
        dense
      >
        <v-col>
          <v-pagination
            v-model="page"
            :length="pagination.total_pages"
            :total-visible="totalVisible"
            circle
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="pageChangeEvent"
          />
        </v-col>
      </v-row>
      <!-- /ページャ -->

    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  name: 'DriverSalesRequest',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      page: 1,
      totalVisible: 7,
      breadcrumbs: [],
      billing: null,
      /** 検索フォーム */
      searchForms: {
        sortType1: null,
        sortType2: null,
        sortType3: null,
        sortType4: null,
        sortType5: null,
      },
      /** 並び替え */
      sortMembers: [
        { value: 'trading_date@asc', text: '取引日昇順' },
        { value: 'trading_date@desc', text: '取引日降順' },
        { value: 'sales_date@asc', text: '売上計上日昇順' },
        { value: 'sales_date@desc', text: '売上計上日降順' },
        { value: 'supplierable_id@asc', text: '排出事業者昇順' },
        { value: 'supplierable_id@desc', text: '排出事業者降順' },
        { value: 'deal_no@asc', text: '取引番号昇順' },
        { value: 'deal_no@desc', text: '取引番号降順' },
        { value: 'billing_output_at@asc', text: '請求書出力昇順' },
        { value: 'billing_output_at@desc', text: '請求書出力降順' },
      ],
      tableHeaders: [
        { value: 'trading_date', text: '取引日\r\n売上計上日' },
        { value: 'emission', text: '排出事業者\r\n排出事業場' },
        { value: 'item_unit_price_code', text: '売上品目コード' },
        { value: 'item_unit_price_name', text: '売上品目名' },
        { value: 'deal_no', text: '取引番号', align: 'center'},
        { value: 'printed', text: '請求書出力', align: 'center' },
        { value: 'quantity', text: '取引数量' , align: 'end'},
        { value: 'sales_item_unit_name', text: '取引単位' },
        { value: 'unit_price', text: '単価' , align: 'end'},
        { value: 'quantity_per_unit', text: '単位あたり' },
        { value: 'detailed_amount', text: '明細金額' , align: 'end'},
      ]
    }
  },
  computed: {
    ...mapState('DriverSalesRequestBillingDetail', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverSalesRequestBillingDetail', [
      'hasResult'
    ]),
  },
  watch: {},
  created() {
    this.breadcrumbs = []
    this.breadcrumbs.push({ text: '請求管理一覧', disabled: false, to: '/driver/sales/requests', exact: true })
    this.breadcrumbs.push({ text: '請求管理詳細', disabled: true, to: '' })

    this.searchRequests()
  },
  methods: {
    ...mapActions('DriverSalesRequestBillingDetail', {
      fetchSalesRequest: 'index'
    }),
    backButtonClickEvent () {
      this.$router.push( { name: 'DriverSalesRequests' } )
    },
    /**
     * 検索ボタン クリックイベント
     */
     searchButtonClickEvent () {
      this.searchRequests()
    },
    /**
     * ページボタン クリックイベント
     */
     pageChangeEvent () {
      this.searchRequests()
    },
    searchRequests () {
      this.fetchSalesRequest({ id: this.$route.params.id, sort_type1: this.searchForms.sortType1, sort_type2: this.searchForms.sortType2, sort_type3: this.searchForms.sortType3,sort_type4: this.searchForms.sortType4,sort_type5: this.searchForms.sortType5,page: this.page }).then((content) => {
        this.billing = content
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
